import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import XrayContent from '../components/XrayContent';

const DentalXrays = () => {
  return (
    <div className="xrays-container" style={{ backgroundColor: "#edffee" }}>
      <Header />
      <XrayContent />
      <Footer />
    </div>
  );
};

export default DentalXrays;